module.exports = __webpack_public_path__ + "media/images/front/premium_lp/pagetitle_01-17bb9a4d15baab794307d0a450c39d0a.png";